export const Disposition = [
    'Good With Other Animals',
    'Good With Children',
    'Must Be Leashed'
];